<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div
      class="container-confirmation-modal cursor-normal flex justify-center px-4"
    >
      <div class="relative flex flex-col items-start rounded bg-white p-6">
        <img
          class="absolute right-4 top-6 h-3 w-3 cursor-pointer"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />
        <div
          class="flex items-center"
          style="margin-left: -5px"
        >
          <svg
            class="h-8 w-8"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.9681 9.72039C15.5378 8.73355 16.9622 8.73355 17.5319 9.72039L24.7108 22.1546C25.2806 23.1415 24.5684 24.375 23.4289 24.375H9.0711C7.93159 24.375 7.21941 23.1414 7.78916 22.1546L14.9681 9.72039Z"
              stroke="#000000"
              stroke-width="2"
            />
            <path
              d="M16.25 13.5V19"
              stroke="#000000"
              stroke-width="2"
            />
            <circle
              cx="16.25"
              cy="21.25"
              r="1.25"
              fill="#000000"
            />
          </svg>
          <h3 class="text-dark-blue">Authorization Required</h3>
        </div>
        <p class="mb-4 text-left text-1md text-body-color">
          Your authorization to represent this carrier must be provided in order
          to prevent fraud and protect your identity.
        </p>
        <p class="mb-4 text-left text-1md text-body-color">
          Click below to send an email to local authorities in your Canadian
          province or territory requesting verification of your authorization to
          represent this carrier.
        </p>
        <p class="mb-4 text-left text-1md text-body-color">
          You or the rightful owner of the carrier may need to provide proof of
          rightful ownership.
        </p>
        <div class="flex w-full flex-col gap-3">
          <button-main
            class="text-1md"
            @click="() => $emit('authorize')"
          >
            Send Authorization Request
          </button-main>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'ConfirmUploadCertificateModal',
  components: {
    Modal,
    ButtonMain,
  },
  props: {
    visible: Boolean,
  },
  emits: ['close'],
};
</script>

<style scoped>
.container-confirmation-modal {
  width: 500px;
}
h3 {
  @apply text-2xl;
}

@media screen and (max-width: 499px) {
  .container-confirmation-modal {
    width: 320px;
  }
  h3 {
    @apply text-xl;
  }
}
</style>
